<template>
  <section class="feature-section pt-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="feature-img">
            <div class="section-heading heading-four text-start" data-aos="fade-down">
              <h2>Best Platform for Car Rental</h2>
              <p>
                Why do we choose relax rent bikes generally if we travel in a un known
                cities with a bike in our hand we feel which is like a home town
              </p>
            </div>
            <img src="@/assets/img/cars/car.png" alt="img" class="img-fluid" />
          </div>
        </div>

        <div class="col-lg-6">
          <div class="row row-gap-4">
            <!-- Feature Item -->
            <div class="col-md-6 d-flex">
              <div class="feature-item flex-fill">
                <span class="feature-icon">
                  <i class="bx bxs-info-circle"></i>
                </span>
                <div>
                  <h6 class="mb-1">Best Deal</h6>
                  <p>Dreams Rent offers a fleet of high-quality</p>
                </div>
              </div>
            </div>
            <!-- /Feature Item -->

            <!-- Feature Item -->
            <div class="col-md-6 d-flex">
              <div class="feature-item flex-fill">
                <span class="feature-icon">
                  <i class="bx bx-exclude"></i>
                </span>
                <div>
                  <h6 class="mb-1">Doorstep Delivery</h6>
                  <p>Dreams Rent offers a fleet of high-quality</p>
                </div>
              </div>
            </div>
            <!-- /Feature Item -->

            <!-- Feature Item -->
            <div class="col-md-6 d-flex">
              <div class="feature-item flex-fill">
                <span class="feature-icon">
                  <i class="bx bx-money"></i>
                </span>
                <div>
                  <h6 class="mb-1">Low Security Deposit</h6>
                  <p>Dreams Rent offers a fleet of high-quality</p>
                </div>
              </div>
            </div>
            <!-- /Feature Item -->

            <!-- Feature Item -->
            <div class="col-md-6 d-flex">
              <div class="feature-item flex-fill">
                <span class="feature-icon">
                  <i class="bx bxs-car-mechanic"></i>
                </span>
                <div>
                  <h6 class="mb-1">Latest Cars</h6>
                  <p>Dreams Rent offers a fleet of high-quality</p>
                </div>
              </div>
            </div>
            <!-- /Feature Item -->

            <!-- Feature Item -->
            <div class="col-md-6 d-flex">
              <div class="feature-item flex-fill">
                <span class="feature-icon">
                  <i class="bx bx-support"></i>
                </span>
                <div>
                  <h6 class="mb-1">Customer Support</h6>
                  <p>Dreams Rent offers a fleet of high-quality</p>
                </div>
              </div>
            </div>
            <!-- /Feature Item -->

            <!-- Feature Item -->
            <div class="col-md-6 d-flex">
              <div class="feature-item flex-fill">
                <span class="feature-icon">
                  <i class="bx bxs-coin"></i>
                </span>
                <div>
                  <h6 class="mb-1">No Hidden Charges</h6>
                  <p>Dreams Rent offers a fleet of high-quality</p>
                </div>
              </div>
            </div>
            <!-- /Feature Item -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
